import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";
import { ChevronDownIcon } from "../../../../common/Icons/Icons";

const BasicSelectError = () => {
  const [age, setAge] = React.useState(10);

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Select with Error"}
        language={"js"}
        value={
          "       <FormControl error>\n" +
          "          <InputLabel>Default</InputLabel>\n" +
          "          <Select\n" +
          "            value={age}\n" +
          "            onChange={handleChange}\n" +
          "            fullWidth\n" +
          "            IconComponent={ChevronDownIcon}\n" +
          "          >\n" +
          "            <MenuItem value={10}>Tom Cook - Default</MenuItem>\n" +
          "            <MenuItem value={20}>Tom Cook - Twenty</MenuItem>\n" +
          "            <MenuItem value={30}>Tom Cook - Thirty</MenuItem>\n" +
          "          </Select>\n" +
          "        </FormControl>"
        }
      >
        <FormControl error>
          <InputLabel>Default</InputLabel>
          <Select
            value={age}
            onChange={handleChange}
            fullWidth
            IconComponent={ChevronDownIcon}
          >
            <MenuItem value={10}>Tom Cook - Default</MenuItem>
            <MenuItem value={20}>Tom Cook - Twenty</MenuItem>
            <MenuItem value={30}>Tom Cook - Thirty</MenuItem>
          </Select>
        </FormControl>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicSelectError;
